var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMyApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.62 13.0093C16.62 11.6936 17.3415 10.4629 18.4449 9.78381C17.7234 8.76523 16.5775 8.12862 15.3468 8.08618C14.0311 7.95886 12.7579 8.85011 12.0788 8.85011C11.3998 8.85011 10.3812 8.08618 9.27772 8.12862C7.83473 8.17106 6.47662 8.97744 5.75513 10.2507C4.2697 12.8396 5.37316 16.7017 6.81615 18.8237C7.53764 19.8423 8.38646 21.0306 9.48992 20.9882C10.5509 20.9457 10.9753 20.3091 12.291 20.3091C13.6067 20.3091 13.9462 20.9882 15.0921 20.9882C16.238 20.9457 17.0019 19.9272 17.681 18.9086C18.1903 18.1447 18.5723 17.3383 18.8693 16.4895C17.5112 15.8953 16.62 14.5372 16.62 13.0093Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4553 6.72793C15.092 5.964 15.4315 4.98786 15.3466 4.01172C14.3705 4.0966 13.4792 4.56345 12.8426 5.28494C12.206 6.00644 11.8665 6.94014 11.9513 7.91627C12.9275 7.95871 13.8612 7.49187 14.4553 6.72793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyApple);
export default __webpack_public_path__ + "static/media/ic_my_apple.3910abea14a64de97d641ce4f5e2a543.svg";
export { ForwardRef as ReactComponent };